import React from "react";
import "./tarjeta.scss";
import { Divider } from "@mui/material";
import BotonAtomico from "../../../../../../components/PartesAtomicas/BotonAtomico";
import RouterLogo from "../../../../../../assets/ROUTER.png";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const Tarjeta = ({ title1, accion, title, info, onClick, children, credenciales = null }) => {
  return (
    <div className="tarjeta container-tarjeta compact">
      <div className="estadoCuenta__detalles deuda">
        {/* Contenedor para centrar la imagen */}
        <div className="router-logo-container">
          <img src={RouterLogo} alt="Router Logo" />
        </div>

        <div className="deuda">
          <div className="deuda__estado">
            <h2 className="deuda__estado__label">
              {title1}
              <span className={`deuda__estado_label__valor deuda`}> {title}</span>
            </h2>
          </div>

          <h2 className="info__label">
            {info}
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>
              {credenciales && credenciales.nombre_red}
            </span>
          </h2>

          {children}

          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              marginTop: "2rem",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
              {!accion.includes("Volver") ? (
                <BotonAtomico tipo="button" label={accion} colorCorp={0} onClick={onClick} />
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    color: "#00657D",
                    fontWeight: "bold",
                  }}
                  onClick={onClick}
                >
                  <KeyboardArrowUpIcon />
                  <span style={{ marginLeft: "0.5rem" }}>Cerrar</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tarjeta;